import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { LANGUAGES } from "../lib/constants";

export const useRTLDirection = () => {
  const { i18n } = useTranslation();

  useEffect(() => {
    const initializeDirection = () => {
      const currentLang = LANGUAGES.find((lang) => lang.code === i18n.language);
      if (currentLang) {
        document.documentElement.lang = i18n.language;
        document.documentElement.dir =
          currentLang.direction === "rtl" ? "rtl" : "ltr";
      }
    };

    // Initialize on mount
    if (i18n.isInitialized) {
      initializeDirection();
    }

    // Listen for language changes
    const handleLanguageChange = () => {
      initializeDirection();
    };

    const handleInitialized = () => {
      initializeDirection();
    };

    i18n.on("languageChanged", handleLanguageChange);
    i18n.on("initialized", handleInitialized);

    return () => {
      i18n.off("languageChanged", handleLanguageChange);
      i18n.off("initialized", handleInitialized);
    };
  }, [i18n]);
};
